export const supportedLanguages = [
	{ code: 'en', name: 'English' },
	{ code: 'es', name: 'Español' },
	{ code: 'fr', name: 'Français' },
]

export const supportedWordsLanguages = [
	{ code: 'ar', name: 'Arabic', flip: true },
	{ code: 'cs', name: 'Czech' },
	{ code: 'da', name: 'Danish' },
	{ code: 'de', name: 'German' },
	{ code: 'en', name: 'English' },
	{ code: 'es', name: 'Spanish', flip: true },
	{ code: 'fi', name: 'Finnish' },
	{ code: 'fr', name: 'French', flip: true },
	{ code: 'hi', name: 'Hindi' },
	{ code: 'hu', name: 'Hungarian' },
	{ code: 'it', name: 'Italian', flip: true },
	{ code: 'ja', name: 'Japanese' },
	{ code: 'ko', name: 'Korean' },
	{ code: 'nl', name: 'Dutch' },
	{ code: 'pl', name: 'Polish' },
	{ code: 'pt', name: 'Portuguese', flip: true },
	{ code: 'ru', name: 'Russian' },
	{ code: 'sv', name: 'Swedish' },
	{ code: 'tr', name: 'Turkish' },
	{ code: 'zh', name: 'Chinese' },
]
